import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  standalone: false,
    selector: 'app-submit-score-report',
    templateUrl: './submit-score-report.component.html',
    styleUrls: ['./submit-score-report.component.scss'],
})
export class SubmitScoreReportComponent {
    @Input() matchUpScoreValidation: any;
    constructor(
        private modalController: ModalController
    ) { }

    async continue() {
        (await this.modalController.getTop()).dismiss(true);
    }

    close() {
        this.modalController.dismiss();
    }

}
